module.exports = __webpack_public_path__ + "img/ifsc-logo.979f8c57.png";